import "./index.css";
import { useMemo, useRef } from "react";
import { Outlet } from "react-router";
import type { IAuthPageContext } from "../../types";
import { AuthPageContext } from "../../context/AuthPageContext";
import { I18nextProvider } from "react-i18next";
import { i18n } from "../../locales";
import Logo from "@/assets/illustrations/logo.png";
import { useAppStore } from "@/store/app/slice";
import { AuthState } from "@/types/common";

const Auth = () => {
  const authenticated = useAppStore((s) => s.authenticated);
  const usernameRef = useRef<string>("");
  const passwordRef = useRef<string>("");

  const context = useMemo((): IAuthPageContext => {
    return {
      passwordRef,
      usernameRef,
    };
  }, []);

  if (authenticated === AuthState.Authenticated) {
    return null;
  }

  return (
    <AuthPageContext.Provider value={context}>
      <I18nextProvider i18n={i18n}>
        <div className="nuco-auth__underlay">
          <div className="nuco-auth">
            <header className="nuco-auth__header">
              <img src={Logo} alt="QuickConnex" className="nuco-auth__header-img" />
            </header>
            <div className="nuco-auth__main">
              <Outlet />
            </div>
          </div>
        </div>
      </I18nextProvider>
    </AuthPageContext.Provider>
  );
};

export default Auth;
